/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CultureSettings {
    angular.module("meevo.plugins.cultureSettings", []);
}